<template>
  <div class="all-games">
    <Game v-for="game in allGames" :key="game.key" :game="game" />
  </div>
</template>

<script>
import Game from "./Game"

export default {
  props: ["allGames"],
  components: {
    Game,
  },
  computed: {

  },
}
</script>

<style lang="scss" scoped>
.all-games {
  display: flex;
  flex-wrap: wrap;
  margin: 2rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/game/AllGames.vue